import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = ''
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState('USD');
  const [locale, setLocale] = useState('en-US');
  const [multiplier, setMultiplier] = useState(1);
  useEffect(() => {
    // Simple locale detection and currency mapping
    const userLocale = navigator.language || 'en-US';
    setLocale(userLocale);
    if (userLocale.startsWith('es-MX')) {
      setCurrency('MXN');
      setMultiplier(20); // Approx rate
    } else if (userLocale.startsWith('es-CO')) {
      setCurrency('COP');
      setMultiplier(4000); // Approx rate
    } else if (userLocale.startsWith('es-AR')) {
      setCurrency('ARS');
      setMultiplier(1000); // Approx rate (volatile, using rough estimate)
    } else if (userLocale.startsWith('es-CL')) {
      setCurrency('CLP');
      setMultiplier(950); // Approx rate
    } else if (userLocale.startsWith('es-PE')) {
      setCurrency('PEN');
      setMultiplier(3.8); // Approx rate
    } else if (userLocale.startsWith('es')) {
      // Default for other Spanish speakers (Spain, etc) often prefer EUR or USD
      // Keeping USD as per instructions for default/fallback
      setCurrency('USD');
      setMultiplier(1);
    } else {
      setCurrency('USD');
      setMultiplier(1);
    }
  }, []);
  const formatPrice = (val: number) => {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(val * multiplier);
  };
  return <span className={`inline-flex items-center gap-2 ${className}`} data-id="element-138">
      {originalAmount && <span className="text-gray-500 line-through text-0.8em decoration-red-500/50 decoration-2" data-id="element-139">
          {formatPrice(originalAmount)}
        </span>}
      <span data-id="element-140">{formatPrice(amount)}</span>
    </span>;
}